import { connect } from 'react-redux';
import IntlMessages from '../../utils/IntlMessages';
import Login from './login';
import AuthLayout from '../../layouts/AuthLayout';

const AuthForm = () => {
	
		return (
          <AuthLayout>
            <main className='container main-for-login'>
              <div className='row'>
                <div className='col-md-6 mx-auto'>
                  <div className="container div4 div2 rounded-for-login">
                    <div className="form-side">
                      <h3 className="text-center mb-4 mt-2"><IntlMessages id='login'/></h3>
                        <Login />
                      </div>
                    </div>
                </div>
              </div>
            </main>
          </AuthLayout>
		)
}
export default connect(null, null)(AuthForm);

